<!--人才服务  -->
<template>
  <div>
    <el-container>
      <el-header class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
        </div>
        <p>人力资源</p>
      </el-header>
      <el-main class="mainContent">
        <div class="searchpart">
          <el-row :gutter="20">
            <el-col :span="18">
              <el-row :gutter="20" class="searchline">
                <el-col :span="12">
                  <el-input
                    placeholder="姓名"
                    v-model="formData.name"
                  ></el-input>
                </el-col>
                <el-col :span="12">
                  <el-input
                    placeholder="联系方式"
                    v-model="formData.phone"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="searchline">
                <el-col :span="12">
                  <el-select placeholder="学历" v-model="formData.educationId">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select
                    v-model="formData.isEmployment"
                    placeholder="是否就业"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row class="searchline">
                <el-button round class="searchBtn" @click="searchList"
                  >查询</el-button
                >
              </el-row>
              <el-row class="searchline">
                <el-button round type="info" @click="resetform">重置</el-button>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div v-infinite-scroll="load">
          <div
            v-for="(item, index) in listdata"
            :key="index"
            class="contentPart"
          >
            <div class="lineContent">
              <el-row class="contTitle">
                <el-col :span="12"><span>姓名：</span>{{ item.name }}</el-col>
                <el-col :span="12"
                  ><span>联系方式：</span>{{ item.phone }}</el-col
                >
              </el-row>
              <el-row class="contTitle">
                <el-col :span="12"
                  ><span>学历：</span>{{ item.educationName }}</el-col
                >
                <el-col :span="12"
                  ><span>是否就业：</span
                  >{{ isEmployment(item.isEmployment) }}</el-col
                >
              </el-row>
            </div>
          </div>
          <!-- <p v-if="loading" style="margin-top: 10px" class="loading">
            <span></span>
          </p>
          <p
            v-if="noMore"
            style="margin-top: 10px; font-size: 13px; color: #ccc"
          >
            没有更多了
          </p> -->
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          value: "d770ed89448a95938cde19a96706131c",
          label: "文盲",
        },
        {
          value: "3221f02046e9673065a98ace6cac19a7",
          label: "半文盲",
        },
        {
          value: "53ae5ceb3cd59b5998217e9fcaa1cd44",
          label: "小学",
        },
        {
          value: "f01d5512d3982b99f307e71d04ffc04e",
          label: "初中",
        },
        {
          value: "ce98beb1be1dcb369b2021ded2cf205d",
          label: "高中",
        },
        {
          value: "4061b42bbe97c8b8619f363e23123632",
          label: "中等技术学校",
        },
        {
          value: "7a558dc04c215c14e803ed3f9a39f131",
          label: "中等专业学校",
        },
        {
          value: "322c2a1876facb55d1d4063dd20650c9",
          label: "大学专科",
        },
        {
          value: "616e464b120c7eebabda382ad92be252",
          label: "大学本科",
        },
        {
          value: "8bfa5f0ce80daf958912d1bdc1060f1f",
          label: "研究生",
        },
        {
          value: "90025cc5c6a1435923d99526a0752d49",
          label: "其他",
        },
      ],
      options2: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      pagesize: 10,
      listdata: [],
      count: 1,
      loading: false,
      totalpages: 0,
      formData: {
        name: "",
        phone: "",
        educationId: "",
        isEmployment: "",
      },
    };
  },

  components: {},
  computed: {
    noMore() {
      //当起始页数大于总页数时停止加载
      return this.count >= this.totalpages - 1;
    },
    disabled() {
      return this.loading || this.noMore;
    },
    isEmployment() {
      return function (val) {
        return val == 1 ? "是" : "否";
      };
    },
  },
  created() {
    this.getList();
  },

  mounted() {},

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    load() {
      //滑到底部时进行加载
      this.loading = true;
      this.count += 1; //页数+1
      this.getList(); //调用接口，此时页数+1，查询下一页数据
    },
    getList() {
      let url = "/dev-api/talent/humanInfoByPage";
      let params = {
        size: this.pagesize * this.count,
        page: 1,
      };
      Object.assign(params,this.formData)
      this.$httpApi.get(url, params).then((r) => {
        this.listdata = r.data;
        this.loading = false;
        this.totalpages = r.pages;
      });
    },
    searchList(){
      this.count=1
      this.getList()
    },
    resetform() {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = "";
      });
      this.getList()
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  z-index: 100;
  width: 100%;
  height: 5.25rem !important;
  background-color: #36aa60;
  position: relative;
  .header-wrap {
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
    .header-img {
      width: 30px;
      height: 30px;
      margin-top: 1rem;
    }
  }
  p {
    height: 20px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    line-height: 4;
    letter-spacing: 0.5rem;
  }
}
.mainContent {
  padding-top: 0;
  height: calc(100vh - 100px);
  overflow: hidden;
  overflow-y: scroll;
  .contentPart {
    width: 100%;
    position: relative;
    .lineContent {
      border-bottom: 1px solid #bbb;
      .contTitle {
        height: 40px;
        line-height: 40px;
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        div {
          color: #000;
          span {
            color: #bbb;
          }
        }
      }
    }
  }
  .searchpart {
    border-bottom: 1px solid #bbb;
    .searchline {
      margin: 20px auto;
    }
  }
}
.searchBtn {
  background-color: #36ab60;
  color: #fff;
}
::v-deep {
  .el-input__inner {
    border-radius: 13px;
  }
}
.loading span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #409eff;
  border-left: transparent;
  animation: zhuan 0.5s linear infinite;
  border-radius: 50%;
}
</style>